<script lang="ts">
  import Row from "./Row.svelte";

  export let fillerColor: "yellow" | "gray";
</script>

<slot />
<Row color={fillerColor} filler />
